import styled from '@emotion/styled';
import { fontSize } from 'src/domains/common/universes/star/starsports.config';
import { LogoGambleAwareV2 } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGambleAwareV2';
import { LogoGamblingHelpline } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamblingHelpline';
import { withConfig } from 'src/withConfig';

export const ResponsibleGamblingLinksText = withConfig(theme => styled('span', { label: 'ResponsibleGamblingLinksText' })<{type: 'primary' | 'secondary'}>`
    font-size: ${fontSize.xSmall};
    color: ${({ type }): string => type === 'primary' ? theme.star.iconContainer.txtColor : theme.star.iconContainer.txtColorSecondary};
`);

export const LogoGamblingHelplineWrapper = styled(LogoGamblingHelpline, { label: 'LogoGamblingHelplineWrapper' })`
    width: 78px;
`;

export const LogoGambleAwareV2Wrapper = styled(LogoGambleAwareV2, { label: 'LogoGambleAwareV2Wrapper' })`
    width: 91px;
`;
